"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ContainerHolder_1 = __importDefault(require("../Container/ContainerHolder"));
const Range_1 = __importDefault(require("../Util/Range"));
const mostRecentStartOfWeek_1 = __importDefault(require("../Util/mostRecentStartOfWeek"));
const endOfWeekAfter_1 = __importDefault(require("../Util/endOfWeekAfter"));
const moment_1 = __importDefault(require("moment"));
const config_consts_1 = require("../Container/config.consts");
const getInstance = () => {
    return ContainerHolder_1.default.getInstance().get("DATE_TIME_PROVIDER");
};
const getBridge = () => {
    return ContainerHolder_1.default.getInstance().get("DATE_TIME_BRIDGE");
};
const getLocaleConfig = () => {
    return ContainerHolder_1.default.getInstance().get(config_consts_1.CONFIG_LOCALE);
};
exports.default = {
    currentDateTime: (timeZone) => getInstance().current(timeZone),
    currentDate: () => getInstance().currentDate(),
    weekRangeForDate: (date) => new Range_1.default(getBridge().userDate((0, mostRecentStartOfWeek_1.default)(getBridge().systemDate(date))), getBridge().userDate((0, endOfWeekAfter_1.default)(getBridge().systemDate(date)))),
    asDateObject: (date) => new Date(getBridge().systemDate(date)),
    prettyDate: (date) => (0, moment_1.default)(getBridge().systemDate(date))
        .locale(getLocaleConfig().toString())
        .format("dddd DD MMMM"),
    systemDate: (userDate) => getBridge().systemDate(userDate),
    userDate: (systemDate) => getBridge().userDate(systemDate),
};
//# sourceMappingURL=DateTimeUtil.js.map